/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description PetType
 */

export enum PetType {
  CAT = 1,
  SMALL_DOG = 2,
  LARGE_DOG = 3,
}

Object.defineProperty(PetType, '__ENUM_NAME', {
  value: 'PetType',
  writable: false,
  configurable: false,
  enumerable: false,
})
